import React,{useState,useEffect} from "react"
import { Card, CardBody, Col, Row, Spinner } from "reactstrap"
import ReactApexChart from "react-apexcharts"
import { getSalesChartData } from "helpers/backend_helper"

const SalesChart = props => {

  const [seletedMonth, setSeletedMonth] = useState("15d")
  const [series, setSeries] = useState([])
  const [options, setOptions] = useState(getOptions())
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    getSalesData(seletedMonth,'saleschart')
    return () => {
      setSeries([])
    }
  }, []);

  const onChangeMonth = value => {
    setSeletedMonth(value)
    getSalesData(value,'saleschart')
  }

  const getSalesData = async(input,type) => {
    setLoading(true)
    getSalesChartData({
      key : input,
      id: type
    }).then(response => {
      if(response.series){
        setSeries(response.series)
        setOptions({
          ...options,
          xaxis: {
            categories: response.xaxisCategories
          }
        })
        setLoading(false)
      }
    })
  }

  /*
  const series = [
    {
      name: "Current",
      data: [18, 21, 45, 36, 65, 47, 51, 32, 40, 28, 31, 26],
    },
    {
      name: "Previous",
      data: [30, 11, 22, 18, 32, 23, 58, 45, 30, 36, 15, 34],
    },
  ]
*/
  function getOptions(){
    return {
      chart: {
        height: 350,
        type: "area",
        toolbar: {
          show: true,
        },
      },
      colors: ["#34c38f", "#556ee6"],
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "smooth",
        width: 2,
      },
      fill: {
        type: "gradient",
        gradient: {
          shadeIntensity: 1,
          inverseColors: false,
          opacityFrom: 0.45,
          opacityTo: 0.05,
          stops: [20, 100, 100, 100],
        },
      },
      xaxis: {
        categories: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
      },
  
      markers: {
        size: 3,
        strokeWidth: 3,
  
        hover: {
          size: 4,
          sizeOffset: 2,
        },
      },
      legend: {
        position: "top",
        horizontalAlign: "center",
      }
    }
  }

  return (
    <React.Fragment>
      <Col xl={8}>

        <Card>
          <CardBody>
            <div className="clearfix">
              
              
              <div className="float-end">
                <div className="input-group input-group">
                  <select
                    className="form-select form-select-sm"
                    value={seletedMonth}
                    onChange={(e) => {
                      onChangeMonth(e.target.value)
                    }}
                  >
                    <option value="15d">Last 15 Days</option>
                    <option value="30d">Last 1 Month</option>
                    <option value="3m">Last 3 Months</option>
                    <option value="6m">Last 6 Months</option>
                    <option value="11m">Last 1 Year</option>
                  </select>
                </div>
              </div>
              {loading && <div className="float-end">
               <Spinner style={{ width: '1.5rem', height: '1.5rem' }} className="mx-1" color="primary" />
              </div> 
              }
              <h4 className="card-title mb-4">Sales</h4>
            </div>

            <div id="area-chart" dir="ltr">
              
              <ReactApexChart
                options={options}
                series={series}
                type="area"
                height={350}
                className="apex-charts"
              />
            </div>
          </CardBody>
        </Card>
      </Col>
    </React.Fragment>
  )
}

export default SalesChart
